import Vue from 'vue';

export default Vue.component('edit-droplet-copyright', {
  template: require('./template.html'),
  name: 'edit-droplet-copyright',
  props: ['droplet', 'show-edit-bubble'],
  data() {
    return {
      text: '',
    };
  },
  created() {
    this.setInitialValues();
  },
  methods: {
    setInitialValues() {
      this.text = this.droplet.text || '';
    },
    setDropletVal() {
      this._debounce(() => {
        const val = this.text.trim() !== '' ? this.text : false;
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: 'text',
          val,
        });
      }, 200);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/copyright/components/_edit-options/index.js